<template>
    <div class="card-buttons">
        <!--JOINED but no id -->

        <template v-if="!isJoined">
            <div class="card-btn__copy">
                Join SK Club now to activate your SK Club
                Standard Bank 4FOR3 Benefit.
            </div>
            <div class="card-btn__copy" v-if="moreInfoLink">
                <sk-button primary block tag="a" :href="moreInfoLink" target="_blank">More Info</sk-button>
            </div>
            <div class="card-btn__copy" v-if="activationLink">
                <sk-button secondary block tag="a" :href="activationLink" target="_blank">Get A
                    Card
                </sk-button>
            </div>
        </template>

        <!--person is activated-->
        <template v-else-if="isJoined && isLinked">
            <div class="membership">
                <template>
                    Book a movie now and get 4 tickets for the price of 3 when paying with any Standard Bank Credit Card.
                </template>
            </div>
        </template>
        <!--not activated but is joined with sk club-->
        <template v-else>
            <sk-form id="link-card-form-sk-club" @submit="onLink(thisCardNumber)">
                <!--Link Copy-->
                <div class="card-btn__copy" v-if="!isLinked">
                    Have a Standard Bank Credit Card? Activate this
                    exclusive benefit by entering your ID number now.
                </div>
                <!-- Link Buttons-->
                <template>
                    <template v-if="!isLinked">
                        <div class="card-btn__copy">
                            <sk-input v-model="thisCardNumber" placeholder="ID Number" required>
                            </sk-input>
                        </div>
                        <div class="card-btn__copy">
                            <sk-button primary block type="submit" :loading="linking">
                                Activate
                            </sk-button>
                        </div>
                        <div class="card-btn__copy">
                            <sk-button secondary block tag="a" href="https://www.standardbank.co.za/southafrica/personal/products-and-services/bank-with-us/credit-cards/our-cards" target="_blank">
                                Get A Card
                            </sk-button>
                        </div>

                    </template>
                    <!-- <template v-else-if="showCardAdder">

                        <template>
                            <div class="card-btn__copy">
                                <sk-input v-model="thisCardNumber" placeholder="ID Number" required idNumber>
                                </sk-input>
                            </div>
                        </template>
                        <template>
                            <div class="card-btn__copy">
                                <sk-button primary block type="submit" :loading="linking">
                                    Activate
                                </sk-button>
                            </div>
                            <div class="card-btn__copy">
                                <sk-button secondary block @click.native.stop="showCardAdder = false"
                                           :disabled="linking">
                                    Cancel
                                </sk-button>
                            </div>

                        </template>
                    </template> -->
                </template>
            </sk-form>
        </template>
    </div>
</template>

<script type="application/javascript">
    import cardMixin from './cardMixin'
    export default{
        name: 'cardSb',
        mixins: [cardMixin],
    }
</script>


// WEBPACK FOOTER //
// card-sb4for3.vue?362871f4